import TranslatedTextInput from './component';
import { TranslatedTextInputProps } from './types';

export type { TranslatedTextInputProps };
export default TranslatedTextInput;
